export const icons = {
  profile:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930647433_image_profile.svg",
  Setting:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930878243_image_setting.svg",
  Permissions:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750930963173_image_Permissions.svg",
  Name: "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931206478_image_Name.svg",
  Email:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931279045_image_Email.svg",
  "Phone Number":
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931317885_image_Phone%20Number.svg",
  Status:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931378859_image_Status.svg",
  Organization:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931492867_image_Organization%20Name.svg",
  ID: "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931492867_image_Organization%20Name.svg",
  Address:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931597431_image_Address.svg",
  Place:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931762593_image_City.svg",
  Date: "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750931818380_image_Date.svg",
  Area: "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933181973_image_Carpet%20Area.svg",
  Balcony:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933234302_image_Balcony.svg",
  Bathroom:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933256314_image_Bathroom.svg",
  Bedroom:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933280610_image_Bedrooms.svg",
  Category:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933308232_image_Category.svg",
  Kitchen:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933356681_image_Kitchen.svg",
  Tower:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933379706_image_Towers.svg",
  Parking:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933429064_image_Parking.svg",
  Amenities:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933457246_image_View%20Amenities.svg",
  "Around this":
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750933536881_image_AroundProject.svg",
  Price:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750936383010_image_Price.svg",
  Cancelled:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750938388804_image_BookingCancelled.png",
  Completed:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750938508050_image_BookingCompleted.png",
  Processed:
    "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750938455566_image_BookingProcessed.png",
  Card: "https://mrproptekbucket.s3.ap-south-1.amazonaws.com/1750939702082_image_dashboardCard.png",
};
